// Polyfill for process variable
if (typeof process === 'undefined') {
  window.process = { 
    env: {
      NODE_ENV: 'development',
      REACT_APP_GA_MEASUREMENT_ID: ''
    }
  };
}
